import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// UNSECURED LOAN VERIFICATION (New / Existing top-up / Return)
// Legacy: /AccountsApproval/VerifyUnsecuredLoan, VerifyUnsecuredLoanExisting, VerifyUnsecuredLoanReturn —
// three grids sharing VerifyNewLoanView and one approve action; the loan type picks the SP server-side.
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue for one loan type ('New' | 'Existing' | 'Return').
export const getVerificationUnsecuredLoans = async (roleId, type) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationUnsecuredLoans`, { params: { Roleid: roleId, type }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail by bank transaction ref no (carries MOID, bank payment and type-specific amounts).
export const getLoanByRefNo = async (transRefNo, type) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetLoanbyRefno`, { params: { TransRefno: transRefNo, Type: type }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spApproveUnsLoanNew | TopUp | Return — success literal "Submited").
export const approveLoan = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveLoan`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
